import React, { PureComponent } from 'react';
import { measureItems, CSSGrid, makeResponsive } from 'react-stonecutter';

const Grid = makeResponsive(measureItems(CSSGrid, { measureImages: true }), {
  maxWidth: 1024,
  minPadding: 0,
});
// const { pinterest } = layout;

class SearchGallery extends PureComponent {
  render() {
    const { projects } = this.props;
    return (
      <div className="search">
        <Grid
          component="ul"
          columns={4}
          columnWidth={245}
          itemHeight={200}
          // gutterWidth={10}
          // gutterHeight={10}
          duration={500}
          springConfig={{ stiffness: 170, damping: 26 }}
          // layout={pinterest}
        >
          {projects}
        </Grid>
      </div>
    );
  }
}

export default SearchGallery;



// WEBPACK FOOTER //
// ./src/components/SearchGallery.js